import React from 'react';
import { Box, Typography } from '@mui/material';
import { VariantSummary as StyledVariantSummary } from './styles';
import { QueryVariantWithClinvar } from '../../types/genomic';

interface Props {
  variants: QueryVariantWithClinvar[];
}

export const VariantSummary: React.FC<Props> = ({ variants }) => {
  const total = variants.length;
  const byGeneCount = new Set(
    variants.flatMap(variant => 
      variant.clinvar.allele.GeneList?.Gene?.map(g => g.Symbol) || []
    )
  ).size;
  const byChromosome = new Set(variants.map(v => v.chromosome)).size;

  return (
    <StyledVariantSummary>
      <Box>
        <Typography variant="body2" color="text.secondary">Total Variants</Typography>
        <Typography variant="h4" color="primary">{total}</Typography>
      </Box>
      <Box>
        <Typography variant="body2" color="text.secondary">Genes Affected</Typography>
        <Typography variant="h4" color="primary">{byGeneCount}</Typography>
      </Box>
      <Box>
        <Typography variant="body2" color="text.secondary">Chromosomes</Typography>
        <Typography variant="h4" color="primary">{byChromosome}</Typography>
      </Box>
    </StyledVariantSummary>
  );
}; 